export const withHidden =
  <P extends object>(Component: React.FunctionComponent<P>) =>
  (props: P & { hidden?: boolean }) => {
    if (props.hidden) return null;
    return <Component {...props} />;
  };
